<mobi-product-layout [entity]="entity()" />
